<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <form action="" @submit.prevent="save()">
            <cards title="Form Data KPI" headerclass="abc" headerstyle="background-color: #ebeffb;"
              footerstyle="background-color: #ebeffb;" :useHeader="true" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton>Simpan</ArgonButton>
                    <ArgonButton type="button" outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <template v-slot:header-action>
                <div>
                  <ArgonButton :to="{ name: 'Master Data Kpi' }" isRouteLink outline>Kembali</ArgonButton>
                </div>
              </template>
              <form>
                <FieldsetComponent title="Informasi Umum"
                  description="Pastikan informasi ini disi dengan tepat sesuai dengan asrama dan kelas santri">
                  <div class="flex flex-col gap-5">
                    <form-group label="Kode KPI" idinput="code">
                      <input type="text" name="code" id="code" class="form-control" v-model="data.code">
                    </form-group>

                    <form-group label="Judul" idinput="title">
                      <input type="text" name="title" id="title" class="form-control" v-model="data.title">
                    </form-group>

                    <form-group label="Bobot" idinput="weight">
                      <input type="text" name="weight" id="weight" class="form-control" v-model="data.weight">
                    </form-group>

                    <form-group label="Target" idinput="target">
                      <input type="text" name="target" id="target" class="form-control" v-model="data.target">
                    </form-group>

                    <form-group label="Satuan" idinput="unit">
                      <input type="text" name="unit" id="unit" class="form-control" v-model="data.unit">
                    </form-group>
                  </div>
                </FieldsetComponent>
              </form>
            </cards>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import KpiApi from "@/repository/api/KpiApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
import RealisasiKpiApi from "@/repository/api/RealisasiKpiApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import InputGroup from "@/components/InputGroup.vue";
// import Avatar from "@/components/Avatar.vue";
import ArgonButton from "@/components/ArgonButton.vue";


export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      data: {},
      unitKerja: [
        {}
      ],
      selectedEmployeeAdd: "",
      optionEmployee: [
        {
          id: "abc",
          text: "xyz",
        },
      ],
      jabatan: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: '',
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    // Select2,
    // InputGroup,
    // Avatar,
    ArgonButton
  },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
    await this.getEmployee();
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
  },
  methods: {
    async unassignKpi(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        text: "Jika anda unassign pegawai maka progress pegawai tersebut untuk kpi terkait akan ikut dihapus",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await RealisasiKpiApi.delete(id).then(async () => {
            this.$swal({
              icon: "success",
              title: "Berhasil Unassign"
            })
            await this.getRealisasi();
          })
          this.$store.state.loading = false;
        }
      });
    },
    async getRealisasi() {
      this.$store.state.loading = true;
      await RealisasiKpiApi.getbyparam({ kpi_id: this.$route.params.id }).then((response) => {
        this.data.realisations = response.data
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      })
      this.$store.state.loading = false;
    },
    async assignEmployee(data) {
      this.$store.state.loading = true;
      this.selectedEmployeeAdd = data.id;
      await RealisasiKpiApi.post({
        employee_id: this.selectedEmployeeAdd,
        kpi_id: this.$route.params.id
      }).then(async () => {
        this.$swal({
          icon: "success",
          text: "Assigned"
        })
        await this.getRealisasi();
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      });
      this.$store.state.loading = false;
    },
    getSelectedUnitKerja() {
      return this.unitKerja.find((item) => {
        return item.id == this.data.unit_kerja_id;
      });
    },
    async getOptionUnitKerja() {
      this.optionUnitKerja = this.unitKerja.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.get().then(async (response) => {
        this.unitKerja = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada unit kerja"
        });
      });
      await this.getOptionUnitKerja();
      this.$store.state.loading = false;
    },
    async getOptionJabatan() {
      this.optionJabatan = this.jabatan.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.get().then((response) => {
        this.jabatan = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "Belum ada jabatan"
        });
      });
      await this.getOptionJabatan();
      this.$store.state.loading = false;
    },
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text })
    },
    async save() {
      this.$store.state.loading = true;
      if (this.$route.params.id) {
        await KpiApi.update(this.$route.params.id, this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Master Data Kpi" });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: error.response.data.message,
            });
          });
        })
      }
      else {
        await KpiApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Master Data Kpi" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await KpiApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error.response.data.message,
        }).then(() => {
          this.$router.push({ name: "Dashboard" });
        });
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
